export const enum BadgeType {
	accent = 'accent',
	white = 'white'
}